import styled from "styled-components";

export const ProfilePictureDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: -4.5rem 0 2rem 0;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
        margin-bottom: 0.5rem;
    }
`;
